export default "__VITE_ASSET__EI30C4zJ__"